import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { maxTries: Number }

  // img can also be a video element
  static targets = ["img"]

  connect() {
    if (!this.hasImgTarget) return

    this.loadCount = 0
    this.src = this.imgTarget.src
    this.dataSrc = this.imgTarget.dataset.src

    if (this.dataSrc && "IntersectionObserver" in window) {
      this.observer = new IntersectionObserver(this.#intersection, {
        threshold: 0,
      })
      this.observer.observe(this.element)
    } else {
      this.#startLoading()
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  loaded() {
    this.element.classList.remove("is-loading")
  }

  error() {
    if (this.maxTriesValue == 0) return

    this.loadCount += 1

    if (this.loadCount < this.maxTriesValue) {
      this.#updateSrc(`${this.src || this.dataSrc}#${this.loadCount}`)
    } else if (this.loadCount == this.maxTriesValue) {
      this.#updateSrc(this.element.dataset.paintingMissingUrlValue)
    }
  }

  #intersection = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.#startLoading()
        this.imgTarget.src = this.dataSrc
      }
    })
  }

  #startLoading() {
    if (!this.#isImageLoaded()) this.element.classList.add("is-loading")
  }

  #isImageLoaded() {
    const media = this.imgTarget

    // video elements
    if (media.readyState == 4) return true

    // https://stackoverflow.com/a/1977898/311657
    return media.complete && media.naturalWidth
  }

  #updateSrc(src) {
    const sources = Array.from(this.element.querySelectorAll("source"))
    sources.forEach(source => source.remove())
    this.imgTarget.src = src
  }
}
